import { isEmpty } from 'lodash';
import { ReserveButtonProps } from 'types';
import { Button } from '../../button';
import { Tooltip } from '../../tooltip';

export default function ReserveButton(props: ReserveButtonProps) {
  return (
    <>
      {props.isVehicleReserved ? (
        <div>
          <Tooltip content={props.reservationInfoText} ariaLabel enabledCondition={!isEmpty(props.reservationInfoText)}>
            <Button
              variant={'red'}
              appearance="outline"
              onClick={props.onReserveVehicle}
              className="flex w-full justify-center items-center hover:bg-lightDestructive enabled:hover:bg-lightDestructive"
            >
              <span>Opphev reservasjon</span>
            </Button>
          </Tooltip>
        </div>
      ) : (
        <Tooltip content={props.reservationInfoText} ariaLabel enabledCondition={!isEmpty(props.reservationInfoText)}>
          <Button
            className="w-full"
            variant="teal"
            onClick={props.onReserveVehicle}
            disabled={props.isReservationInWaiting || props.isSelectedVehicleUnavailable}
            isLoading={props.isLoading}
          >
            <span>Reserver bil</span>
          </Button>
        </Tooltip>
      )}
    </>
  );
}
